import React from 'react';
import { Text } from '@react-three/drei';

interface ElectronicScaleProps {
  position?: [number, number, number];
  rotation?: [number, number, number];
  scale?: number;
  readingG?: number;
  showSaltPile?: boolean;
}

export function ElectronicScale({
  position = [0, 0, 0],
  rotation = [0, 0, 0],
  scale = 1,
  readingG = 0,
  showSaltPile = false,
}: ElectronicScaleProps) {
  const baseW = 0.5;
  const baseD = 0.42;
  const baseH = 0.06;
  const panW = 0.32;

  const pileScale = Math.min(1, readingG / 40);
  const pileR = 0.03 + 0.04 * pileScale;
  const pileH = 0.005 + 0.018 * pileScale;

  return (
    <group position={position} rotation={rotation} scale={scale}>
      <mesh castShadow receiveShadow>
        <boxGeometry args={[baseW, baseH, baseD]} />
        <meshStandardMaterial color="#1f2937" roughness={0.45} metalness={0.25} />
      </mesh>
      <mesh position={[0, baseH / 2 - 0.001, baseD / 2 - 0.07]}>
        <boxGeometry args={[0.22, 0.012, 0.07]} />
        <meshStandardMaterial color="#0a0f1a" roughness={0.2} metalness={0.1} />
      </mesh>
      <mesh position={[0, baseH / 2 + 0.0065, baseD / 2 - 0.07]}>
        <planeGeometry args={[0.20, 0.05]} />
        <meshBasicMaterial color="#7fdcff" />
      </mesh>
      <Text
        position={[0, baseH / 2 + 0.008, baseD / 2 - 0.07]}
        rotation={[-Math.PI / 2, 0, 0]}
        fontSize={0.035}
        color="#0a1a2a"
        anchorX="center"
        anchorY="middle"
        fontWeight={900}
      >
        {`${readingG.toFixed(1)} g`}
      </Text>
      <mesh position={[0, baseH / 2 + 0.012, 0.04]} castShadow>
        <cylinderGeometry args={[panW / 2, panW / 2, 0.005, 48]} />
        <meshStandardMaterial color="#cbd5e1" roughness={0.35} metalness={0.6} />
      </mesh>
      {showSaltPile && readingG > 0 && (
        <mesh position={[0, baseH / 2 + 0.014 + pileH / 2, 0.04]}>
          <coneGeometry args={[pileR, pileH * 2, 24]} />
          <meshStandardMaterial color="#f8fafc" roughness={0.95} />
        </mesh>
      )}
      <Text
        position={[-0.16, baseH / 2 + 0.001, baseD / 2 - 0.18]}
        rotation={[-Math.PI / 2, 0, 0]}
        fontSize={0.012}
        color="#94a3b8"
        anchorX="center"
        anchorY="middle"
      >
        TARE
      </Text>
    </group>
  );
}

export default ElectronicScale;
